<template>
<div :class="(Mobile)?'':'col-lg-4'">
    <div id="mobileMenu" :class="(Mobile)?'main-aside':'sidebar sticky-sidebar user-nav sidebar-left'">
        <div class="aside-title header-sidebar" v-if="Mobile">
                <div class="aside-controls">
                    <router-link tag="div" to="/" class="vx-logo cursor-pointer flex items-center">
                        <h4>هنزاگلد</h4>
                    </router-link>
                    <div @click="toggleMenu" class="close-btn close-dark">
                        <span></span>
                        <span></span>
                    </div>
                </div>
            </div>
        <div :class="(Mobile)?'aside-scroll' : ''">
            <ul>
                <li @click="toggleMenu" v-if="Mobile">
                    <a href="https://henzagold.shop/"
                                 class="nav-link flex items-center">
                        <span class="feather-icon select-none relative w-5 h-5 rtl:ml-3 ltr:mr-3 grow-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-home">
                                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
                                <polyline points="9 22 9 12 15 12 15 22"/>
                            </svg>
                        </span>
                        <span class="truncate">بازگشت به فروشگاه</span>
                    </a>
                </li>
                <li @click="toggleMenu">
                  <router-link to="/dashboard" active-class="active"
                               class="nav-link flex items-center">
                          <span class="feather-icon select-none relative w-5 h-5 rtl:ml-3 ltr:mr-3 grow-icon">
                              <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-align-justify">
                                  <line x1="21" y1="10" x2="3" y2="10"></line>
                                  <line x1="21" y1="6" x2="3" y2="6"></line>
                                  <line x1="21" y1="14" x2="3" y2="14"></line>
                                  <line x1="21" y1="18" x2="3" y2="18"></line>
                              </svg>
                          </span>
                    <span class="truncate">داشبورد</span>
                  </router-link>
                </li>
                <li @click="toggleMenu">
                    <router-link to="/profile" active-class="active"
                    class="nav-link flex items-center">
                        <span class="feather-icon select-none relative w-5 h-5 rtl:ml-3 ltr:mr-3 grow-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-heart">
                                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                                <circle cx="12" cy="7" r="4"></circle>
                            </svg>
                        </span>
                        <span class="truncate">پرفایل کاربری</span><!---->
                    </router-link>
                </li>
                <li @click="toggleMenu">
                    <router-link to="/wish-list" active-class="active"
                    class="nav-link flex items-center">
                        <span class="feather-icon select-none relative w-5 h-5 rtl:ml-3 ltr:mr-3 grow-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-heart">
                                <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
                            </svg>
                        </span>
                        <span class="truncate">علاقمندی ها</span>
                    </router-link>
                </li>
                <li @click="toggleMenu">
                    <router-link to="/my-orders"
                    class="nav-link flex items-center" active-class="active"
                    target="_self">
                        <span class="feather-icon select-none relative w-5 h-5 rtl:ml-3 ltr:mr-3 grow-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"
                            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" class="feather feather-shopping-bag ">
                                <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>
                                <line x1="3" y1="6" x2="21" y2="6"></line>
                                <path d="M16 10a4 4 0 0 1-8 0"></path>
                            </svg>
                        </span>
                        <span class="truncate">
                            سفارش های من
                        </span><!---->
                    </router-link>
                </li>
                <li @click="toggleMenu">
                    <router-link to="/checkout" active-class="active"
                    class="nav-link flex items-center">
                        <span class="feather-icon select-none relative w-5 h-5 rtl:ml-3 ltr:mr-3 grow-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-shopping-cart ">
                                <circle cx="9" cy="21" r="1"></circle>
                                <circle cx="20" cy="21" r="1"></circle>
                                <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
                            </svg>
                        </span>
                        <span class="truncate">سبد خرید</span><!---->
                    </router-link>
                </li>
                <li @click="toggleMenu">
                    <router-link to="/my-transactions" active-class="active"
                    class="nav-link flex items-center">
                        <span class="feather-icon select-none relative w-5 h-5 rtl:ml-3 ltr:mr-3 grow-icon">
<!--                            <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-dollar-sign ">
                                <line x1="12" y1="1" x2="12" y2="23"></line>
                                <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
                            </svg>-->
                          <Icon icon="ion:journal-outline"  style="font-size: 24px;color: inherit"/>
                        </span>
                        <span class="truncate">تراکنش های مالی</span><!---->
                    </router-link>
                </li>
                <li @click="toggleMenu">
                    <router-link to="/my-address" active-class="active"
                    class="nav-link flex items-center">
                        <span class="feather-icon select-none relative w-5 h-5 rtl:ml-3 ltr:mr-3 grow-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-map-pin ">
                                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                                <circle cx="12" cy="10" r="3"></circle>
                            </svg>
                        </span>
                        <span class="truncate">آدرس های من</span><!---->
                    </router-link>
                </li>
                <li>
                    <a @click="Log_Out" class="rejectBtn nav-link flex items-center">
                        <span class="feather-icon select-none relative w-5 h-5 rtl:ml-3 ltr:mr-3 grow-icon">
<!--                            <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-log-out">
                                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                                <polyline points="16 17 21 12 16 7"></polyline>
                                <line x1="21" y1="12" x2="9" y2="12"></line>
                            </svg>-->
                            <Icon icon="ion:log-out-outline"  style="font-size: 24px;color: inherit"/>
                        </span>
                        <span class="truncate">خروج</span>
                    </a>
                </li>
            </ul>
        </div>
    </div>
    <div class="aside-overlay aside-trigger" @click="toggleMenu"></div>
</div>
</template>

<script>
import {Icon} from "@iconify/vue2"
export default {
    props:{togglePreLoader:Function},
    components: {
      Icon
    },
    data () {
        return {
            Mobile: false
        }
    },
    methods: {
        Log_Out () {
            const appLoading = document.getElementById('loading-bg')
            if (appLoading && appLoading.classList.contains('hidden')) {
                appLoading.classList.toggle("hidden");
            }
            localStorage.removeItem ('accessToken')
            localStorage.removeItem ('userInfo')
            this.$router.push('/login')
            if (appLoading && !appLoading.classList.contains('hidden')) {
                appLoading.classList.toggle("hidden");
            }
        },
        Sidebar (event) {
            if (event.currentTarget.innerWidth <992) {
                this.Mobile = true
            }
            else {
                this.Mobile = false
            }
        },
        toggleMenu () {
            document.getElementById("mobileMenu").classList.toggle('open');
            document.body.classList.toggle('aside-open');
        }
    },
    created() {
        window.addEventListener("resize", this.Sidebar);
        this.Mobile = (window.innerWidth >= 992)? false : true
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.Sidebar);
    }/*,
    mounted() {
        var trigger = document.getElementsByClassName("aside-trigger")
        for(let t of trigger) {
            t.onclick = function () {
                document.getElementById("mobileMenu").classList.toggle('open');
                document.body.classList.toggle('aside-open');
            }
        }
    }*/
}
</script>

<style lang="css" scoped>
.grow-icon{
    flex-grow: .1;
}
.main-aside{
    padding: 20px 0 !important;
}
.vs-sidebar-group {
    padding: 0 15px;
}
.aside-overlay {
    z-index: 41001;
}
.main-aside .aside-scroll {
    padding-top: .5rem;
}
.sticky-sidebar {
    top: 110px;
}
.main-aside a {
    padding: 10px 15px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    align-items: center;
    color: var(--primary-color) !important;
    font-weight: 400;
    transition: 0s;
}
</style>
